






























import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";

export default Vue.extend({
  name: "RevokeOwner",
  components: { UserAvatar },
  props: {
    member: Object,
    show: Boolean,
  },
  data() {
    return {
      cancellationOption: "endOfPeriod",
      currentMember: {
        id: 0,
        name: "",
        memberAvatarImageUrl: null,
        emailAddress: "",
        isPreregistered: false,
        role: NaN,
      },
      rules: {
        role: [
          {
            required: true,
            type: "number",
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["currentBillingAccountInviteRoles"]),
    showModal(): any {
      return this.show;
    },
    today() {
      return moment().format("MMM D, YYYY");
    },
    billingAccountEndDate() {
      let context = this as any;
      return context.billingAccount ? moment(context.billingAccount.currentPlanEndDate).format("MMM D, YYYY") : "";
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        let context = this as any;
        context.currentMember.id = context.member.memberId;
        context.currentMember.isPreregistered = context.member.memberIsPreregistered;
        context.currentMember.name = context.member.memberName;
        context.currentMember.memberAvatarImageUrl = context.member.memberAvatarImageUrl;
        context.currentMember.emailAddress = context.member.memberEmailAddress;
        context.currentMember.role = NaN;
      }
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleSave(event) {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this as any;

      (context.$refs["UserForm"] as any).validate((valid) => {
        if (valid) {
          let data = {
            memberId: context.currentMember.id,
            role: context.currentMember.role,
            email: context.currentMember.emailAddress,
            name: context.currentMember.name,
            billingAccountId: context.billingAccount.id,
          };

          this.$store
            .dispatch("billing/updateMember", {
              data: data,
            })
            .then((response) => {
              context.$store.dispatch("billing/getBillingAccountInfo", {
                id: context.billingAccount.id,
              });
              context.$emit("cancel");
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
          return;
        }
      });
    },
  },
});
